import angular from 'angular';
import hemCalculator from './hemCalculator';

export default angular
  .module('components.hemCalculator', [])
  .component('hemCalculator', hemCalculator).name;
